import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Preloader from './components/Home/Preloader';
import Header from './components/Home/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import RideOptions from './pages/RideOptions';
import AndroidDownload from './pages/AndroidDownload';
import DriverPage from './pages/DriverPage';
import RiderPage from './pages/RiderPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';

function App() {
  return (
    <Preloader>
      <Router>
        <div className="App">
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/ride-options" element={<RideOptions />} />
            <Route path="/android-download" element={<AndroidDownload />} />
            <Route path="/driver" element={<DriverPage />} />
            <Route path="/rider" element={<RiderPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            {/* Other routes will be added as pages are created */}
          </Routes>
          <Footer />
        </div>
      </Router>
    </Preloader>
  );
}

export default App;